module.exports = __webpack_public_path__ + "static/media/summary-icon-compare.58fe74dc.svg";